import * as waveData from "./waveData.json";
import * as zombieData from "./zombieData.json";
export class Waves {
	currentWaveIndex = 1;
	currentWave = 1;
	zombiesPerWave = 4;
	waveDelayStartTime: number;
	waveDelayStarted = false;
	flagDefaults = {
		DoorID0: false,
		DoorID1: false,
		DoorID2: false
	};
	// TODO expose a multiplier to apply to zombie health, maybe even item prices
	flags: { [index: string]: boolean | string | number };
	constructor() // world: Phaser.Physics.Arcade.World,
	{
		// super(world, scene, {
		// 	classType: Zombie,
		// 	runChildUpdate: true,
		// });
	}
	// This is where the sprite sheets are loaded. with the frame sizes determined by measuring the sprite sheets in paint.
	preload(scene: Phaser.Scene): void {
		// nothing to preload
	}
	// This is run to initialize the everything.
	create(scene: Phaser.Scene): void {
		const json: { [index: string]: WaveJSON } = waveData;
		this.flags = {};
		Object.assign(this.flags, this.flagDefaults);
	}

	// This is run with the scene update funcitons, so when the frame updates, so will this, the zombie manager.
	update(time: number, delta: number, scene: Phaser.Scene): void {
		const json: { [index: string]: WaveJSON } = waveData;
	}

	getCurrentWave(): WaveJSON {
		const json: { [index: string]: WaveJSON } = waveData;
		return json[this.currentWaveIndex];
	}

	getCurrentWaveNumber(): number {
		return this.currentWave;
	}

	getZombiesForWave(): string[] {
		const waveJSON: { [index: string]: WaveJSON } = waveData;
		let quantity: number;
		const zombieQuantity: number =
			waveJSON[this.currentWaveIndex].quantityModifer *
			this.zombiesPerWave *
			this.currentWave;
		const zombieArray: string[] = [];
		for (const zombieSpawn of waveJSON[this.currentWaveIndex].zombies) {
			const zombiesToSpawn: number = Math.round(
				(zombieQuantity * zombieSpawn.quantity) / 100
			);
			for (quantity = 0; quantity < zombiesToSpawn; quantity += 1) {
				zombieArray.push(zombieSpawn.zombieType);
			}
		}
		return zombieArray;
	}

	updateFlag(flagID: string, value: boolean | string | number): void {
		const json: { [index: string]: WaveJSON } = waveData;
		if (this.flags[flagID] === undefined) {
			throw new Error(`flagID [${flagID}] is not a valid flag ID!`);
		}
		this.flags[flagID] = value;
	}

	isInWaveDelay(): boolean {
		return this.waveDelayStarted;
	}

	getTimeUntilNextWave(time: number): number {
		const json: { [index: string]: WaveJSON } = waveData;
		if(this.waveDelayStarted === false) {
			return 0;
		}
		return ((this.waveDelayStartTime - time + json[this.currentWaveIndex + 1].delayAfterWave)/1000);
	}

	advanceWave(time: number): boolean {
		const json: { [index: string]: WaveJSON } = waveData;
		const futureWave: WaveJSON | undefined = json[this.currentWaveIndex + 1];
		if (
			this.waveDelayStarted === true &&
			this.waveDelayStartTime + json[this.currentWaveIndex + 1].delayAfterWave < time
		) {
			if (json[this.currentWaveIndex + 1]) {
				if (futureWave.requirements.length) {
					for (const requirement of futureWave.requirements) {
						if (this.flags[requirement] === undefined) {
							throw new Error(
								`Requirement [${requirement}] in wave ${this.currentWaveIndex +
									1} is undefined! Check your spelling!`
							);
						}
						if (this.flags[requirement] === false) {
							this.waveDelayStarted = false;
							this.currentWave = this.currentWave + 1;
							return false;
						}
					}
				}
				this.waveDelayStarted = false;
				this.currentWaveIndex = this.currentWaveIndex + 1;
				this.currentWave = this.currentWave + 1;
				return true;
			}
			this.currentWave = this.currentWave + 1;
			return false;
		} else {
			if (this.waveDelayStarted === false) {
				this.waveDelayStarted = true;
				this.waveDelayStartTime = time;
			}
			return false;
		}
	}
}
